<template>
  <div>
    <v-row>
      <div class="card-body">
        <div>
          <form>
            <div class="form-group">
              <label for="executorLabel">Izvrsilac :</label>
              <select class="form-control" id="executorLabel" v-model="person">
                <option v-for="admin in getAdmins" :key="admin.index">{{
                  admin
                }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="locationLabel">Lokacija :</label>
              <select
                class="form-control"
                id="locationLabel"
                v-model="location"
              >
                <option
                  v-for="location in getOptions.location"
                  :key="location.index"
                  >{{ location }}</option
                >
              </select>
            </div>
            <div class="form-group">
              <label for="workTime"> Vrsta termina :</label>
              <select class="form-control" id="workTime" v-model="workTime">
                <option v-for="work in getOptions.workTime" :key="work.index">{{
                  work
                }}</option>
              </select>
            </div>
            <div class="form-group mt-2">
              <label for="workTimeUnit">Jedinica mjere :</label>
              <select
                class="form-control"
                id="workTimeUnit"
                disabled="disabled"
              >
                <option selected="true">Sat</option>
              </select>
            </div>
            <div class="form-group">
              <label for="amountOfWork">Kolicina</label>
              <input
                type="number"
                class="form-control"
                id="amountOfWork"
                min="1"
                value="1"
                v-model="workTimeSpent"
              />
            </div>
            <div class="form-group">
              <label for="cityLabel">Grad :</label>
              <select class="form-control" id="cityLabel" v-model="city">
                <option v-for="city in getOptions.city" :key="city.index">{{
                  city
                }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="description">Opis</label>
              <textarea
                class="form-control"
                id="description"
                rows="3"
                v-model="description"
              ></textarea>
            </div>
            <div class="form-check mb-2">
              <input
                type="checkbox"
                class="form-check-input"
                id="usedMaterials"
                v-model="usedMaterial"
              />
              <label class="form-check-label" for="usedMaterials"
                >Da li je koristen potrosni materijal</label
              >
            </div>

            <!-- <div v-for="a in b">
                <p>{{ a }}</p>
              </div> -->

            <!-- <div class="form-group" v-if="usedMaterial">
              <h3>Potrosni materijal :</h3>
              <div v-if="usedMaterials && usedMaterials.length > 0">
                <div v-for="(material, index) in usedMaterials" :key="index">
                  <component
                    ref="mats"
                    :is="'used-materials'"
                    :id="index + 1"
                    :data="material"
                  >
                  </component>
                </div>
              </div>
              <button
                type="button"
                class="btn btn-outline-primary"
                title="Dodaj potrosni materijal"
                @click="addNewMaterial"
              >
                +
              </button>
              <button
                type="button"
                class="btn btn-outline-danger"
                title="Izbrisi potrosni materijal"
                @click="removeMaterial"
              >
                -
              </button>
            </div> -->
            <!-- <button type="submit" class="btn btn-primary" v-if="added">
              Dodaj zadatak
            </button> -->
          </form>
        </div>
      </div>
    </v-row>
  </div>
</template>
<script>
import EventBus from "@/eventBus";

export default {
  data() {
    return {
      props: {
        data: Object
      },
      person: "",
      location: "",
      workTimeSpent: 0,
      city: "",
      description: "",
      usedMaterial: "",
      added: false,
      workTime: ""
    };
  },
  mounted() {
    /*eslint-disable*/
    // console.log(this.data);
    EventBus.$on("NEW_TASK", response => {
      console.log(response);
      if (response) {
        this.getData();
      } else {
        this.$store.commit("removeTempTasks");
      }
    });
  },
  computed: {
    getTempWorklog() {
      return this.$store.getters.getTempWorklog;
    },
    getAdmins() {
      return this.$store.getters.getAdmins;
    },
    getOptions() {
      return this.$store.getters.getOptions;
    }
  },
  methods: {
    getData() {
      const task = {};
      task.person = this.person;
      task.location = this.location;
      task.city = this.city;
      task.description = this.description;
      task.usedMaterial = this.usedMaterial;
      task.workTimeSpent = this.workTimeSpent;
      task.workTime = this.workTime;
      this.$store.commit("setTempTasks", task);
    }
  }
};
</script>
<style></style>
